import React from 'react';
import {
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  NavRight,
  Link,
  List,
  ListInput,
  ListItem,
  Row,
  Col,
  Button,
  BlockTitle,
  Block,

} from 'framework7-react';

import { PrimaryLogo, ChatBotSvg } from '../components/crumbs';

class MessageMaster extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      messageID: props.f7route.params.id,
      previousView: props.f7route.params.view,
      previousPage: props.f7route.params.page,
    }
  }

  render() {
    return (
      <Page name="message-master" onPageAfterIn={this.onPageAfterIn.bind(this)}>
        {/* Top Navbar */}
        <Navbar sliding={false}>
          <NavLeft>
            <Link iconF7="chevron_left" className="message-master-backbtn-desktop" tabLink={this.state.previousPage == "account" ? "#view-account" : "#view-map"}>Back</Link>
          </NavLeft>
          <NavTitle sliding>
            <PrimaryLogo size="132" />
          </NavTitle>
        </Navbar>

        {/* Page content */}
        <Block>

        </Block>
        <List>
            <ListItem link="/404/">
              {/* {"/message-detail/message-master/admin/"+this.state.previousPage+"/"} */}
                <div slot="media" style={{padding: "5px", backgroundColor: "#fed448", width: "40px", height: "40px"}}><PrimaryLogo/></div>
                <h5 slot="title">Admin</h5>
                <small slot="after">14:05</small>
            </ListItem>
        </List>

        <div className="blankDetailSVG">
          <ChatBotSvg size="300px"/>
          <p>Select user to start conversation.</p>
        </div>
      </Page>
    );
  }

  //events
  onPageAfterIn() {
    const self = this;
    // Todo: use id from props to load message-detail

    // if(self.props.f7route.params.id !== "back"){
    //   self.$f7.preloader.show();
    //   setTimeout(function(){
    //     self.$f7router.navigate({
    //       name: "message-detail",
    //       params: {id: self.props.f7route.params.id}
    //     });
    //     self.$f7.preloader.hide();
    //   }, 500);
    // }
    if(self.props.f7route.params.id !== "back"){
      self.$f7router.navigate({
        name: "message-detail",
        params: {view: this.props.f7route.params.view, id: this.props.f7route.params.id, page: this.props.f7route.params.page}
      });
    }
  }
}

export default MessageMaster;
